import React from 'react';
import ReactDOM from 'react-dom/client';  // Use 'react-dom/client' in React 18+

import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './app/store';  // Assuming your store.js is in this path

const root = ReactDOM.createRoot(document.getElementById('root'));  // Create root

root.render(
  <Provider store={store}>  {/* Wrap App with Provider for Redux store */}
    <App />
  </Provider>
);
